import {
  Box,
  Button,
  // HStack,
  Image,
  // Stack,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import PdfIcon from "assets/svg/pdf.svg";
import { ReactComponent as UploadIcon } from "assets/svg/upload.svg";
import isEmpty from "lodash/isEmpty";
import { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";

export const Thumbs = ({ previewFiles }) => {
  return (
    <>
      {previewFiles &&
        previewFiles.map((file) => (
          <Box
            key={file?.name}
            w="100%"
            maxH="240px"
            h="100%"
            position="absolute"
            top="0"
            left="0"
            zIndex="1"
          >
            <Box>
              <Image
                w="100%"
                maxH="240px"
                objectFit="contain"
                src={file?.preview}
              />
            </Box>

            {file.type === "application/pdf" && (
              <Box
                pos="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
              >
                <VStack>
                  <Image boxSize="60px" src={PdfIcon} />
                  <Text textAlign="center" fontSize="sm">
                    {file.name}
                  </Text>
                </VStack>
              </Box>
            )}
          </Box>
        ))}
    </>
  );
};

const Uploader = ({ files, onFiles, renderer, changeButtonText, maxFiles }) => {
  const toast = useToast();
  const ONE_MB = 1048576; // 1 Megabyte === 1048576 Byte;

  const [_files, setFiles] = useState(
    files && !isEmpty(files)
      ? files.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      : []
  );

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragReject,
    rejectedFiles,
    open,
  } = useDropzone({
    minSize: 0,
    maxSize: ONE_MB * 5,
    maxFiles: maxFiles ?? 10,
    accept: "image/jpg, image/jpeg, image/png, application/pdf",
    onDrop: (acceptedFiles) => {
      onFiles && onFiles(acceptedFiles);
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  // console.log("REJECTED FILES", _files);

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      _files.forEach((file) => URL.revokeObjectURL(file?.preview));
    },
    [_files]
  );

  useEffect(() => {
    rejectedFiles?.length > 0 &&
      rejectedFiles?.forEach((file) => {
        if (file.size > ONE_MB * 5)
          toast({
            position: "bottom-right",
            title: "Oops!!",
            description: "File is too large",
            status: "error",
            duration: 9000,
            isClosable: true,
          });
      });
  }, [rejectedFiles, toast]);

  const renderDropZone = () => {
    const Default = ({ rootProps, inputProps, files }) => (
      <Box
        w="100%"
        minH="180px"
        border="2px dashed #03A438"
        borderRadius="16px"
        cursor="pointer"
        pos="relative"
        overflow="hidden"
        {...rootProps}
      >
        <input {...inputProps} />
        {/* <input type="file" /> */}
        {isEmpty(_files) && (
          <VStack
            w="100%"
            minH="180px"
            justifyContent="center"
            pos="relative"
            zIndex="1"
            bg="rgba(3, 164, 56, 0.05)"
          >
            <Box fontSize="38px" as={UploadIcon} />
            <VStack justifyContent="center" mt="0 !important">
              <Text color="black">
                {!isDragActive && "Upload your files here"}
                {isDragActive && !isDragReject && "Drop it like it's hot!"}
                {isDragReject && "File type not accepted, sorry!"}
              </Text>
              {!isDragActive && (
                <Text
                  cursor="pointer"
                  color="var(--primary)"
                  textDecoration="underline"
                  mt="0 !important"
                >
                  Browse
                </Text>
              )}
            </VStack>
          </VStack>
        )}

        {/* <Preview /> */}
        <Thumbs previewFiles={files} />
      </Box>
    );

    return !renderer
      ? Default({
          rootProps: getRootProps(),
          inputProps: getInputProps(),
          files: _files,
          isDragReject: isDragReject,
          isDragActive: isDragActive,
        })
      : renderer({
          rootProps: getRootProps(),
          inputProps: getInputProps(),
          files: _files,
          isDragActive,
          isDragReject,
          open,
        });
  };

  return (
    <VStack w="100%">
      {/* <Box
        w="100%"
        minH="240px"
        border="2px dashed #03A438"
        borderRadius="16px"
        cursor="pointer"
        pos="relative"
        overflow="hidden"
        {...getRootProps()}
      >
        <input {...getInputProps()} />
        {isEmpty(_files) && (
          <Stack
            w="100%"
            minH="240px"
            justifyContent="center"
            pos="relative"
            zIndex="1"
          >
            <HStack justifyContent="center">
              <Image boxSize="48px" src={UploadIcon} />
              <Text color="#03A438">
                {!isDragActive && "Choose"}
                {isDragActive && !isDragReject && "Drop it like it's hot!"}
                {isDragReject && "File type not accepted, sorry!"}
              </Text>
            </HStack>
          </Stack>
        )}


        <Thumbs previewFiles={_files} />
      </Box> */}

      <input {...getInputProps()} />

      {renderDropZone()}

      {!isEmpty(_files) && (
        <Button
          onClick={open}
          size="sm"
          variant="ghost"
          _hover={{
            boxShadow: "0 0 0 3px #06C3448f",
          }}
          _focus={{
            boxShadow: "0 0 0 3px #06C3448f",
          }}
          _active={{
            boxShadow: "0 0 0 3px #06C3448f",
          }}
        >
          {changeButtonText ?? "Change document"}
        </Button>
      )}
    </VStack>
  );
};

export default Uploader;
